import { render, staticRenderFns } from "./VehicleMarker.vue?vue&type=template&id=4c1f2b94&scoped=true"
import script from "./VehicleMarker.vue?vue&type=script&lang=js"
export * from "./VehicleMarker.vue?vue&type=script&lang=js"
import style0 from "./VehicleMarker.vue?vue&type=style&index=0&id=4c1f2b94&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c1f2b94",
  null
  
)

export default component.exports